import React from "react";
import Button from "@atlaskit/button/new";
import DeleteIcon from "@atlaskit/icon/core/delete";
import { setEditorSaved } from "../../../../../../../redux/actions/integrationActions";
import { useDispatch } from "react-redux";
const ScriptVariableDeleteButton = ({ action, uuid, callback }) => {
  const dispatch = useDispatch();

  const onRemoveScript = () => {
    action.scriptedVariables = action.scriptedVariables.filter((scriptedVariable) => scriptedVariable.uuid !== uuid);
    dispatch(setEditorSaved(false));
    callback();
  };
  return (
    <div className="ihub-scripted-var-icons">
    
      <Button iconBefore={DeleteIcon} onClick={onRemoveScript}></Button>
    </div>
  );
};

export default ScriptVariableDeleteButton;
